import React, { useState, useEffect } from "react";
import "./CategoryModal.css"; // ✅ Using the provided CSS
import { AiOutlineClose } from "react-icons/ai";
import { addCategory, updateCategory } from "../../services/categoryService"; // ✅ API Integration

function CategoryModal({ isOpen, onClose, selectedCategory, onCategoryUpdated, setPopupMessage }) {
    const [category_name, setCategoryName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // ✅ Load selected category details for editing
    useEffect(() => {
        if (selectedCategory) {
            setCategoryName(selectedCategory.category_name);
        } else {
            setCategoryName("");
        }
    }, [selectedCategory]);

    const validateForm = () => {
        if (!category_name.trim()) {
            setPopupMessage("Category name is required", "error");
            return false;
        }
        return true;
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        setIsSubmitting(true);
        try {
            if (selectedCategory) {
                // ✅ Update existing category
                await updateCategory(selectedCategory.id, { category_name });
                setPopupMessage("Category updated successfully!", "success");
            } else {
                // ✅ Create new category
                await addCategory({ category_name });
                setPopupMessage("Category added successfully!", "success");
            }
            onCategoryUpdated(); // ✅ Refresh categories - uncommented this line
            onClose(); // ✅ Close modal
        } catch (error) {
            console.error("Error saving category:", error);
            setPopupMessage(`Error: ${error.message || "Failed to save category"}`, "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="category-modal">
            <div className="category-modal-content">
                <button className="category-close-btn" onClick={onClose}>
                    <AiOutlineClose />
                </button>
                <h2>{selectedCategory ? "Edit Category" : "Add Category"}</h2>
                <div className="category-modal-divider"></div>

                <form>
                    <div className="category-form-group">
                        <label>Category Name: <span className="required">*</span></label>
                        <input
                            type="text"
                            value={category_name}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter category name"
                        />
                    </div>

                    <button
                        className="category-register-btn"
                        type="button"
                        onClick={handleSave}
                        disabled={isSubmitting}
                    >
                        {isSubmitting
                            ? "Saving..."
                            : (selectedCategory ? "Update Category" : "Add Category")
                        }
                    </button>
                </form>
            </div>
        </div>
    );
}

export default CategoryModal;